<div class="app-form-field-error-wrapper">
  <span class="app-form-field-error"><ng-content></ng-content></span>
</div>
